import { post, get, phpPost } from "@/util/crmAxios";
import { getBasicUrls } from "../util/config";

// 订单分页查询
export const queryOrderList = params => post('erp/order/queryOrderList', params)

//DL测评组查看学生——关联学员保存接口
export const updateCustomGwAccount = params => post('crm/customer/updateCustomGwAccount', params)

// 学员查询
export const queryCustomStudentInfo = params => post('erp/student/queryCustomStudentInfo', params)

// 新增编辑订单
export const saveOrder = params => post('erp/order/saveOrder', params)

// 获取订单信息
export const findOrder = params => get('/erp/order/findOrder', params)

// 添加收款流水
export const addReceipt = params => post('/erp/order/addReceipt', params)

// 订单详情
export const orderInfo = params => get('/erp/order/orderInfo', params)

// 根据阶段获取单价
export const schoolStagePrice = params => post('/erp/school/schoolStagePrice', params)

// 退款时，根据手机号码和姓名查询学生信息
export const queryStudentInfo = params => post('/erp/student/queryStudentInfo', params)

// 退款时，根据学员获取退费项下拉数据
export const queryGroupDetailByStudentId = params => post('/erp/order/queryGroupDetailByStudentId', params)

// 退款时，根据学员获取订单明细
export const queryOrderDetailByStudentId = params => post('/erp/order/queryOrderDetailByStudentId', params)

// 添加退款信息
export const addRefund = params => post('/erp/student/addRefund', params)

// 退款流水分页
export const queryRefundList = params => post('/erp/student/queryRefundList', params)

// 根据退款id 获取退款详细信息
export const getRefundInfo = params => get('/erp/student/getRefundInfo', params)

// 取消订单
export const cancelOrder = params => post('/erp/order/cancelOrder', params)

// 获取学员的要消费的剩余课时
export const getStudentStageHours = params => post('/erp/student/getStudentStageHours', params)

// 判断校区是否免费
export const checkCampusIsFree = params => post('/erp/student/checkCampusIsFree', params)

// 学员开课-获取电子账户课时和金额信息
export const getCampusPool = params => post('/erp/student/getCampusPool', params)

// 判断学员是否有完款订单
export const checkStudentCompletedOrder = params => get('/erp/order/checkStudentCompletedOrder', params)

// 添加收款流水-获取订单信息
export const getReceiptOrderInfo = params => get('/erp/order/getReceiptOrderInfo', params)

// 学员开课-学员消费
export const studentConsume = params => post('/erp/student/studentConsume', params)

// 创建学习系统账号
export const createLearningAccount = params => post('/erp/school/createLearningAccount', params)
// check学员 师生关系
export const checkTeacherStudentRelations = params => get('/erp/relation/checkTeacherStudentRelations', params)

// 查询学员是否可以开课
export const ordercanStartClass = params => get('/erp/order/canStartClass', params)

// 学员开课-非智适应开课
export const startClass = params => post('/erp/student/startClass', params)

// 校区-更新学生状态和是否显示账号
export const updateStudentAccount = params => post('/erp/school/updateStudentAccount', params)

// 有效人科
export const school_special_info = params => phpPost("/os/school_special_info", params)

// 是否首次开课
export const student_special_info = params => phpPost("/os/student_special_info", params)

// 购买课时包
export const buy_course_hours = params => phpPost("/os/buy_course_hours", params)

//检查相同学科相同(不同)阶段分配时间是否重合
export const check_same_time = params => phpPost("/os/check_same_time", params)

// 获取密码
export const getStudentPass = params => get('/erp/student/getStudentPass', params)

// 校区-更新学生状态和是否显示账号
export const checkStudent = params => post('/erp/order/checkStudent', params)

//获取学生已完款大班课订单科目
export const queryStudentBigClassOrderSubject = params => post('/erp/order/queryStudentBigClassOrderSubject', params)

//订单完款-订单修改
export const modifySimOrderInfo = params => post('/erp/order/modifySimOrderInfo', params)

//订单列表--获取业绩分单
export const getOrderSplit = params => get('/erp/order/getOrderSplit', params)
//订单列表--业绩分单
export const updateOrderSplit = params => post('/erp/order/updateOrderSplit', params)
//根据购买课时获取相关配置
export const getSquirrelHourConfig = params => post('/squirrel/config/getSquirrelHourConfig', params)
//根据手机号码或姓名查询学生信息或者线索信息
export const queryCustomAndStudentNameList = params => get('/erp/student/queryCustomAndStudentNameList', params)
//获取学员已购买导流课学科信息
export const getStudentDiversionCourse = params => get('/squirrel/getStudentDiversionCourse', params)
//获取订单文件接口
export const getOrderFiles = params => post('/erp/order/getOrderFiles', params)
//获取学员列表信息
export const getStudentInfoByStudentIds = params => post('/erp/student/getStudentInfoByStudentIds', params)
//经销商已开业门店列表
export const queryAgentOpeningStoreList = params => post('/erp/student/queryAgentOpeningStoreList', params)
//获取学员列表信息
export const opBatchRelation = params => post('/erp/relation/opBatchRelation', params)
//获得学习机订阅列表
export const getMachineQuery = params => get(getBasicUrls().schoolm + '/manage/machine/getSubscribeV2Info',params)

//持有中通关证
export const getUserValidTmpPassportInfo = params => post(getBasicUrls().schoolm + 'manage/studentDdj/getUserValidTmpPassportInfo',params)

//历史通行证
export const getUserInvalidTmpPassportList = params => post(getBasicUrls().schoolm + 'manage/studentDdj/getUserInvalidTmpPassportList',params)

// 